import { StarFilledIcon } from '@mr-yum/frontend-ui'
import cn from 'classnames'
import React from 'react'

type StarRatingsProps = {
  rating: number
  onChange: (newRating: number) => void
  disabled: boolean
}

type StarIconProps = {
  disabled: boolean
  isStarSelected: boolean
  label: string
  index: number
  onChange: (newRating: number) => void
}

export const StarRatings = ({
  rating,
  onChange,
  disabled,
}: StarRatingsProps) => {
  const starButtonProps = [...Array(5).keys()].map((_, index) => {
    const star = index + 1
    const isStarSelected = star <= rating

    const label = `Star rating ${star}`

    return {
      isStarSelected,
      label,
      index,
      starDisabled: star === rating,
    }
  })

  return (
    <div className="flex space-x-2">
      {starButtonProps.map(({ label, starDisabled, ...rest }) => (
        <StarButton
          key={label}
          disabled={disabled || starDisabled}
          onChange={onChange}
          label={label}
          {...rest}
        />
      ))}
    </div>
  )
}

const StarButton = ({
  disabled,
  isStarSelected,
  label,
  index,
  onChange,
}: StarIconProps) => {
  return (
    <button
      disabled={disabled}
      key={label}
      aria-label={label}
      onClick={() => onChange(index + 1)}
    >
      <StarFilledIcon
        width={50}
        height={50}
        className={cn('transition-colors', {
          'text-[theme(backgroundColor.action-primary-surface)]':
            isStarSelected,
          'text-[theme(backgroundColor.interactive-surface)] hover:text-[theme(backgroundColor.interactive-surface-hover)]':
            !isStarSelected,
        })}
      />
    </button>
  )
}
